import classNames from "components/ui/classNames";
import { Hover } from "react-powerplug";
import { useIntl } from "react-intl";
import type { ICommentOrReplyAuthorFieldsFragment } from "../../lib/graphql/fragments/__generated__/CommentOrReplyAuthorFields.generated";
import Avatar from "../core/Avatar";

interface IAssetDiscussionCommentParticipantsProps {
  participants: ICommentOrReplyAuthorFieldsFragment[];
  totalCount: number;
}

export default function AssetDiscussionCommentParticipants({
  participants,
  totalCount,
}: IAssetDiscussionCommentParticipantsProps) {
  const intl = useIntl();

  if (participants.length === 0) {
    return null;
  }

  const isTruncated = totalCount > participants.length;
  const othersCount = totalCount - participants.length;

  return (
    <Hover>
      {({ hovered, bind }) => {
        return (
          <div className="flex items-center">
            <div {...bind} className="flex items-center">
              {participants.map((participant, index) => {
                const isFirstParticipant = index === 0;

                return (
                  <Avatar
                    key={participant._id}
                    hashValue={participant._id}
                    src={participant.pictureUrl}
                    alt={participant.fullName}
                    title={participant.fullName}
                    squircle={true}
                    size={19}
                    className="text-xs font-bold"
                    style={{
                      zIndex: participants.length - index,
                      // eslint-disable-next-line no-nested-ternary
                      marginLeft: isFirstParticipant ? 0 : hovered ? 4 : -4,
                    }}
                  />
                );
              })}
            </div>

            {isTruncated && (
              <div className="ml-1 inline-flex">
                <div
                  title={intl.formatMessage(
                    {
                      defaultMessage:
                        "{othersCount, plural, one {Outra pessoa também respondeu ao comentário} other {Outras {othersCount} pessoas também responderam}}",
                      description: "Notificações",
                      id: "hWCh8p",
                    },
                    {
                      othersCount,
                    },
                  )}
                  draggable={false}
                  className={classNames(
                    "box-border inline-flex h-[19px] w-[19px] select-none items-center justify-center rounded bg-[#edf0fd] text-xs font-bold text-blue-600",
                    "dark:bg-blue-600/20 dark:text-blue-300",
                  )}
                >
                  <span>+{Math.min(Math.max(othersCount, 0), 9)}</span>
                </div>
              </div>
            )}
          </div>
        );
      }}
    </Hover>
  );
}
